import { BusinessPartnerContext, PurchaseOrderContractTaskPhase } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 0770. 発注案件契約タスクフェーズ一覧
 * [GET] /purchase_order_contract_task_phases
 */
const purchaseOrderContractTaskPhases = (): Promise<PurchaseOrderContractTaskPhase[]> => {
  return axios.get(`/api/purchase_order_contract_task_phases`);
};

export const usePurchaseOrderContractTaskPhases = () => {
  return useQuery({
    queryKey: ['purchase_order_contract_task_phases'],
    queryFn: () => purchaseOrderContractTaskPhases(),
  });
};
